import { render, staticRenderFns } from "./DocumentCollectionSection.vue?vue&type=template&id=15e2934a&scoped=true"
import script from "./DocumentCollectionSection.vue?vue&type=script&lang=js"
export * from "./DocumentCollectionSection.vue?vue&type=script&lang=js"
import style0 from "./DocumentCollectionSection.vue?vue&type=style&index=0&id=15e2934a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e2934a",
  null
  
)

export default component.exports